import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

export type PageType = 'regular' | 'account';

@Component({
  selector: 'cp-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent implements OnInit {
  @Input()
  header: string;

  @Input()
  subHeader?: string;

  @Input()
  fixedWidth?: string;

  @Input()
  type: PageType = 'regular'

  @HostBinding('style.flex')
  flex: string;

  @HostBinding('style.padding')
  padding: string;

  ngOnInit() {
    this.flex = this.fixedWidth ? `0 0 ${this.fixedWidth}` : `1 1 auto`;
    this.padding = `${this.type === 'account' ? 96 : 16}px 96px`;
  }
}
